import React, { useLayoutEffect, useEffect, useState, useRef, useContext} from "react";
import store from "@/redux/store";
import {storeCalenderSettings, setSelectedDate, getTasks, setSelectedUsers} from '@/reducers/CommunicationCycle';

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Switch,Label, Field } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'


export default function ListBox({...props}) {
        const [selected, setSelected] = useState( props?.selected );
        let dataField = props?.dataField;
        let data = props?.data;
        let multiple = false;

    const onChange=(data) => {
        const {onChange} = props;
        setSelected(data);
        if(onChange) {
            onChange(data);
        }
    }
    
    const getSelected=() => {
        if(selected && Array.isArray(selected) && selected.length > 0) {
            return (<span className="block truncate">{selected.length > 0 && selected.map((item) => (<span className="px-2 bg-gray-100 rounded-md mr-2 py-1">{item[dataField]}</span>) )}</span>);
        }
        if(selected) {
            return (<span className="block truncate"><span className="px-2 bg-gray-100 rounded-md mr-2 py-1">{selected[dataField]}</span></span>);
        }
        
        return (<span className="block truncate text-gray-400">Selecteer</span>);
    }

        
        return (
            <div className="flex items-center">


     <Listbox value={selected}  by="key" multiple={multiple} onChange={onChange}>
      
      <div className="relative mt-2 h-12 w-full">

       <ListboxButton className="relative w-full h-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
       {getSelected()}
       
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
          </span>
        </ListboxButton>      
      
        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
            {props?.emptyOption &&
            <Listbox.Option
              key={"empty"}
              value={null}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">Geen gebruiker geselecteerd</span>
            
              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            </Listbox.Option>
            
            
            }
        
          {data && data.length > 0 && data.map((item) => (
            <Listbox.Option
              key={item.key}
              value={item}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">{item[dataField]}</span>
            
              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            </Listbox.Option>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>

            
            </div>
        )
}

